export const replaceAll = (str, search, replacement) => {
  return str?.replace(new RegExp(search, "g"), replacement) || "";
};

export const normalizeText = (text) => {
  if (!text) return "";
  return text
    .normalize("NFD") // rozloží znaky s diakritikou
    .replace(/[\u0300-\u036f]/g, "") // odstráni diakritiku
    .replace(/\s+/g, "-") // nahradí medzery pomlčkami
    .toLowerCase(); // voliteľne – zníži všetko na malé písmená
};
